import { render } from "./MemberTitle.vue?vue&type=template&id=5c18223a"
import script from "./MemberTitle.vue?vue&type=script&lang=js"
export * from "./MemberTitle.vue?vue&type=script&lang=js"

import "./MemberTitle.vue?vue&type=style&index=0&id=5c18223a&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__